// test570
(570 && 0);
